import React from "react";
import Login from "../Login.js";

const Passage = () => {
  return (
    <div className="login-form">
      <Login />
    </div>
  );
};

export default Passage;